import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import {AuthUserService} from '../services/auth-user.service';
import { APP_ROUTES } from 'app/common/constants';
import { POST_LOGIN_REDIRECT_STORAGE_KEY } from '../auth/post-login-redirect';
@Injectable({ providedIn: 'root' })
export class StartGuard implements CanActivate {
  constructor(
      private router: Router,
      private authService: AuthUserService
  ) { }
  canActivate(_next: unknown, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      if (state?.url) {
        sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, state.url);
      }
      this.router.navigate([APP_ROUTES.MAIN]).then(() => null);
      return false;
    }
  }
}